<article class="Paginator">
	<section class="Paginator__info">
		<p class="Paginator__info__label">Página {{ page() }} de {{ maxPages }}</p>
	</section>
	<section class="Paginator__actions">
		<app-icon-button hasTooltip="Prev" buttonSize="medium" color="green" (clicked)="previousPage()">
			<app-icon appIcon [icon]="EIcons.chevronLeftSolid" iconSize="small" />
		</app-icon-button>
		<app-icon-button hasTooltip="Next" buttonSize="medium" color="green" (clicked)="nextPage()">
			<app-icon appIcon [icon]="EIcons.chevronRightSolid" iconSize="small" />
		</app-icon-button>
	</section>
</article>

